import React from 'react';
import '../../assets/css/HeaderVista.css';

import Container from '@mui/material/Container';
// Importamos Grid2 (en v6 ya viene directamente en el core)
import Grid from '@mui/material/Grid2'; 

export default function HeaderVista(props) {
    const { start, icon, titulo, end } = props;

    return (
        <Container className="Headervista" component="main" maxWidth="lg">
            {/* Grid2 usa "container" igual que antes, pero no necesita "item" en los hijos */}
            <Grid container spacing={0} alignItems="center">
                
                {start && (
                    <Grid size={{ xs: 12, md: 1 }} className="start">
                        {start}
                    </Grid>
                )}

                <Grid 
                    size={{ xs: 12, md: start ? 7 : 8 }} 
                    className="titulo"
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        padding: '15px 0px',
                        fontWeight: '700',
                    }}>
                        {icon}
                        <span style={{ marginLeft: '10px', fontSize: '1.5rem' }}>
                            {titulo}
                        </span>
                    </div>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} textAlign={"right"}>
                    {end}
                </Grid>
                
            </Grid>
        </Container>
    );
}